import React, {Component} from 'react';
import {
    Dialog,
    DialogContent,
    Button,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
    Avatar,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Switch,
    Icon,
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxVip from '../../../../store/actionreducers/vip';
import {UecareDropdown, UecareInput} from '../../../../components';
import {connect} from 'react-redux';
import _ from 'lodash';
import {constDataDialogs} from "../../../../constants";

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
});

const initNewVipState = {
    user: {
        avatar: {url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'},
    },
};

const initControllerState = {
    point_action: '加點',
    point: 0,
    groupType: 'person',
    missionPriceTypeId: 1,
    is_add: true,
};

class UseRecordDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {vip: initNewVipState, ...initControllerState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /**
         * no useRecordDialog , no data need to resolve
         */
        if (!this.props.useRecordDialog) return;

        /**
         * After Dialog Open
         */
        if (!prevProps.useRecordDialog || (!prevProps.useRecordDialog.props.open && this.props.useRecordDialog.props.open)) {
            if (this.props.vip &&
                !_.isEqual(this.props.vip, prevState)) {
                this.setState({vip: this.props.vip, ...initControllerState});
            }
        }
    }

    handleClickYesNo = (name, value) => {
        this.setState({[name]: value});
    };

    handleSwitch = (name, value) => {
        this.setState({[name]: value});
    };

    handleDropDownChange = (name, value) => {
        this.setState({[name]: value});
    };

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    };

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.useRecordDialog});
    };

    render() {
        const {classes, refreshVips, plusUseRecord, vip, useRecordDialog} = this.props;
        let {missionPriceTypes} = this.props;

        if (!useRecordDialog || useRecordDialog.props.open === false) return <div/>;


        const groupType = vip.group.type;
        if (groupType.label === 'company') {
            missionPriceTypes = missionPriceTypes.filter(function (missionPriceType) {
                return missionPriceType.label !== 'visit';
            });
        }


        return (
            <Dialog className={classes.root} {...useRecordDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            {`點數操作 - ${this.state.point_action}`}
                        </Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <Avatar className="w-96 h-96" alt="contact avatar" src={this.state.vip.user.avatar.url}/>
                        <Typography variant="title" color="inherit" className="pt-8">
                            {this.state.vip.user.name}
                        </Typography>
                    </div>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">edit</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <FormLabel component="legend">點數操作</FormLabel>
                            <FormGroup>
                                <FormControlLabel
                                    label={(this.state.is_add) ? '加點' : '扣點'}
                                    control={
                                        <Switch
                                            checked={this.state.is_add}
                                            value="is_add"
                                            onChange={(event) => {
                                                const new_is_add = event.target.checked;
                                                this.handleSwitch('is_add', new_is_add);
                                                (new_is_add) ?
                                                    this.handleClickYesNo('point_action', '加點') :
                                                    this.handleClickYesNo('point_action', '扣點');
                                            }}
                                        />
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </div>

                    <UecareDropdown
                        label='服務類型'
                        icon='record_voice_over'
                        name='missionPriceTypeId'
                        id='missionPriceType'
                        className={classes.formControl}
                        value={this.state.missionPriceTypeId}
                        options={missionPriceTypes}
                        onChange={(event) => {
                            this.handleDropDownChange('missionPriceTypeId', event.target.value)
                        }}/>

                    <UecareInput
                        label='前置單據'
                        icon='library_books'
                        name='origin_no'
                        id='origin_no'
                        className={classes.formControl}
                        value={this.state.origin_no || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='備註'
                        icon='note'
                        name='comment'
                        id='comment'
                        className={classes.formControl}
                        value={this.state.comment || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='次數'
                        icon='score'
                        name='point'
                        id='point'
                        inputType='number'
                        className={classes.formControl}
                        value={this.state.point || ''}
                        onChange={(event) => {
                            this.handleDropDownChange('point', event.target.value)
                        }}/>

                </DialogContent>

                <DialogActions className="justify-between pl-16">
                    <Button
                        variant="raised"
                        color="primary"
                        onClick={async () => {
                            try {
                                // update VIP . add point or minus point
                                await plusUseRecord({
                                    vipId: vip.id,
                                    missionPriceTypeId: this.state.missionPriceTypeId,
                                    points: this.state.point,
                                    groupType: vip.group.type,
                                    point_action: this.state.point_action
                                });
                                await refreshVips();
                                this.closeDataDialog();
                            } catch (e) {
                                console.warn('you got an error = ', e);
                            }
                        }}
                    >
                        {this.state.point_action}
                    </Button>
                </DialogActions>

            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        refreshVips: ReduxVip.ActionCreator.refreshVips,
        updateVip: ReduxVip.ActionCreator.updateVip,
        plusUseRecord: ReduxVip.ActionCreator.plusUseRecord,
        closeSecondDataDialog: ReduxGlobal.ActionCreator.closeSecondDataDialog,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
    }, dispatch);
}

function mapStateToProps({global: {dataDialogs}, vip: {vip}, missionPriceType}) {
    return {
        vip,
        useRecordDialog: dataDialogs[constDataDialogs.name.useRecordDialog],
        missionPriceTypes: missionPriceType.list
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(UseRecordDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/UseRecordDialog.js